import React, { useCallback } from 'react';
import { useKanban } from 'react-kanban';
import RefreshIconButton from '../buttons/components/RefreshIconButton';

// Matches the id="CareNeedDashboard" board rendered in Components/CareNeed/CareNeedDashboard.js.
const CARE_NEED_DASHBOARD_BOARD_ID = 'CareNeedDashboard';

const CareNeedDashboardRefreshFilter = () => {
    const kanban = useKanban();

    const handleClick = useCallback(() => {
        kanban.loadBoard(CARE_NEED_DASHBOARD_BOARD_ID);
    }, [kanban]);

    return <RefreshIconButton onClick={handleClick} title="Aktualisieren" />;
};

export default CareNeedDashboardRefreshFilter;
